import React from 'react'
import {
  Folder,
  Kuznia,
  Las,
  PersonalKnife,
  ShefWorkshopIcon,
} from '~src/icons'

export const workshopIcons = {
  'workshop-las': <Las />,
  'workshop-folder': <Folder />,
  'workshop-kuznia': <Kuznia />,
  'workshop-personal': <PersonalKnife />,
  'workshop-shef': <ShefWorkshopIcon />,
}
